import { useApi } from '@/api';
import {
  ActivityCard,
  KpiCard,
  Page,
  PageSkeleton,
  SparkLiquidityLayer
} from '@/components';
import Psm3Icon from '@/components/icons/Psm3Icon';
import { tokensMappingBase } from '@/utils/tokens';
import { Flex, Heading, Box, useIsMobile } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
import Psm3AssetDonutChart from './Psm3AssetShareDonutChart';

export default function PSM3Page() {
  const isMobile = useIsMobile();
  const [data, error] = useApi({
    url: '/base/psm3/'
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <Flex gap="2xs" alignItems="center">
            <Psm3Icon size="5" />
            <Heading size="1">PSM 3</Heading>
          </Flex>
        }
        actions={
          <Flex flexDirection="column" alignItems="flex-end">
            <Box color="muted" fontSize="-2">
              powered by
            </Box>
            <SparkLiquidityLayer
              width={isMobile ? 150 : 200}
              height={isMobile ? 20 : 30}
            />
          </Flex>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Assets"
            data={data}
            field="total_assets"
            options={{ currency: 'USD' }}
          />
        </Flex>
        <HistoricTabs />

        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <Flex gap={['m', 's']} flexDirection="column" width={['100%', '50%']}>
            <KpiCard
              variant="usds"
              title="USDS Balance"
              data={data}
              field="usds_balance"
              options={{
                currency: tokensMappingBase('USDS')
              }}
            />

            <KpiCard
              variant="susds"
              title="sUSDS Balance"
              data={data}
              field="susds_balance"
              options={{
                currency: tokensMappingBase('sUSDS')
              }}
            />

            <KpiCard
              variant="usdc"
              title="USDC Balance"
              data={data}
              field="usdc_balance"
              options={{
                currency: tokensMappingBase('USDC')
              }}
            />
          </Flex>
          <Flex flexBasis="50%" flexDirection="column" alignItems={'center'}>
            <Heading size="3">PSM3 Assets Distribution</Heading>
            <Psm3AssetDonutChart />
          </Flex>
        </Flex>

        <ActivityCard
          url={`/base/psm3/swap-activity/`}
          linkTo="swap-activity"
          title="Swap Activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
